export const JOB_STATUS_LABELS = {
  requested: 'Requested',
  confirmed: 'Confirmed',
  finding_vendor: 'Finding cleaner',
  assigned: 'Assigned',
  in_progress: 'In progress',
  completed: 'Completed',
  cancelled: 'Cancelled',
  closed: 'Closed',
};
